import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { useParams } from 'react-router-dom';
import { Layout, Skeleton, Flex } from 'antd';
import {Helmet} from "react-helmet";
import PostFilter from '../../../components/PostFilter';
import StoryTitle from '../../../components/SrotyTitle';
import Voting from '../../../components/WiwFooter/Voting';
import ButtonHome from '../../../components/Buttons/ButtonHome';
import ButtonReactionAdd from '../../../components/Buttons/ButtonReactionAdd';
import ButtonGlaz from '../../../components/Buttons/ButtonGlaz';
import ButtonStoryAdd from '../../../components/Buttons/ButtonStoryAdd';
import ButtonLoginOrProfile from '../../../components/Buttons/ButtonLoginOrProfile';
import { getUser } from '../../../utils/func';
import { getIdbRow } from '../../../utils/idb.ts';
import api from '../../../services';

const { Header, Content, Footer } = Layout;
const { reactionLoad } = api;

export default function ReactionAdd() {
	const { reactionId } = useParams();
	let storageUser = getUser();
	const [reaction, setReaction] = useState({id: '', story: { title : "", id: ''}});
	const [height_content, setHeightContent] = useState(0);
	const [margin_content, setMarginContent] = useState('0px');
	const [pageTitle, setPageTitle] = useState('');
	const [pageDescription, setPageDescription] = useState('');
	const [loading, setLoading] = useState(true);

	const ref_header = useRef(null);
	const ref_footer = useRef(null);

	function updateSize() {
		setTimeout(() => {
			setHeightContent(window.innerHeight - ref_header.current.clientHeight - ref_footer.current.clientHeight);
			setMarginContent(ref_header.current.clientHeight + 'px');
		}, 100)
	}
	
	useLayoutEffect(() => {
		window.addEventListener('resize', updateSize);
		return () => window.removeEventListener('resize', updateSize);
	}, []);

	useEffect(() => {
		async function handleLoadReaction() {
			await loadReaction();
		}
		handleLoadReaction();
	}, [reactionId]);

	const loadReaction = async () => {
		setLoading(true);
		let response = await reactionLoad({id: reactionId});
		if (response.success) {
			setReaction(response.list[0]);
			setLoading(false);
		}
		/*let response = await getIdbRow('reaction', reactionId);
		console.log(response);
		if (!!response) {
			setReaction(response);
		} else {
			response = await reactionLoad({id: reactionId});
			if (response.success) {
				setReaction(response.list[0]);
			}
		}*/
		updateSize();
	}


	useEffect(() => {
		console.log();
		updateHelmet(reaction);
	}, [reaction]);

	
	/**
	 * Формирование title, meta=description
	 */    
	function updateHelmet() {
		let title = reaction.story.title;
		setPageTitle(title);
		let description = reaction.story.title;
		setPageDescription(description);
	}

	const changeVoting = (scope) => {
		//setAddScope(scope);
	}

	return (
		<Layout style={{ height: "100vh" }}>
			<Helmet>
				<title>{pageTitle}</title>
				<meta name="description" content={pageDescription} />
			</Helmet>
			<Header className="header" ref={ref_header}>
				<PostFilter />
				<StoryTitle /*finish={finish}*/ link={true} reactionId={reactionId} storyId={reaction.story.id} title={reaction.story.title}></StoryTitle>
			</Header>
			<Content className="content-layot" style={{ height: height_content + 'px', top: margin_content }}>
				{loading && <div className="sceleton-reaction-load"><Skeleton active /></div>}
				Форма редактирования, создания {loading.toString()}
			</Content>

			<Footer ref={ref_footer}>
				<Voting storyId={0} reactionId={reactionId} onChange={changeVoting} />
				<Flex justify="space-between" align="center" >
					<ButtonHome />
					<ButtonStoryAdd />
					<ButtonGlaz />
					<ButtonReactionAdd disabled></ButtonReactionAdd>
					<ButtonLoginOrProfile />
				</Flex>
			</Footer>
		</Layout>
	)
}